<template>
    <div>

        <div class="mt-2 d-flex justify-center align-center"> 

            <v-alert  color="white" width='100%'>
                <v-row>

                    <v-col :cols="isMobile ? 12 : 9" class="d-flex align-center justify-center" :class="isMobile ? 'text-center flex-column' : null">
                        <div :class="isMobile ? 'body-1' : ''" class='title '> {{$t('dash_overview.results')}} </div>
                        <div :class="isMobile ? 'body-1' : ''" class="title ml-2 filter-dates"> {{ initDate | dateTransformOnlyDate  }} a {{ endDate | dateTransformOnlyDate }} </div>
                    </v-col>
                    
                    <v-col class="d-flex" :class="isMobile ? 'justify-center' : 'justify-end'">

                        <transition name="router-anim" v-if="btnFilter">

                            <v-row class="d-flex justify-center align-center">

                                <v-col class="d-flex" :class="isMobile ? 'justify-center' : 'justify-end'">

                                    <v-btn 
                                        outlined
                                        small
                                        color='primary'
                                        :class="isMobile ? null : 'mr-3'" 
                                        class="mr-3 btn-filter-change"
                                        @click.native='choseFilter'>

                                        {{$t('dash_overview.filter_data')}} 
                                        <v-icon>mdi-chevron-down</v-icon>

                                    </v-btn>

                                </v-col>

                            </v-row>

                        </transition>

                    </v-col>

                </v-row>
            </v-alert>

        </div>

        <v-container class="" fluid>

            <!-- Pesquisa por data -->

                <v-row :no-gutters='isMobile ? true : false' class="mt-3 d-flex justify-center" v-if="filtering" >

                    <v-col :cols='isMobile ? 12 : 12' class="d-flex flex-column justify-center align-center" >

                        <v-text-field :class="isMobile ? 'mt-4' : null" class="initDate-input" outlined :loading=' loading2' type="date" v-model="initDate" :label="$t('provider_dashboard.init_date')"></v-text-field>

                    </v-col>

                    <v-col :cols='isMobile ? 12 : 12' class="d-flex flex-column justify-center align-center" >

                        <v-text-field outlined class="endDate-input" :loading=' loading2' type="date" v-model="endDate" :label="$t('provider_dashboard.end_date')"></v-text-field>

                    </v-col>

                    <v-col :cols='isMobile ? 12 : 12' class="d-flex flex-column justify-center align-center" >

                        <v-btn color='primary' :block="isMobile ? true : false" class="btn-search btn-filter-apply" small :disabled='!initDate || !endDate' :loading='loading2' @click.native="changePeriod">{{$t('research')}}</v-btn>

                    </v-col>

                </v-row>

        </v-container>

    </div>
</template>

<script>

import { mapActions, mapGetters } from 'vuex';
import { dashOverviewFilters } from '../../../filters/dashOverviewFilters';
import { GET_DASHDATA } from '../../../store/mutations';

export default {

    name: 'FilterContainer',

    data() {
        return {
            initDate: '',
            endDate: new Date(),
            loading2: false,
            filtering: false,
            filterAlert: false,
            btnFilter: true
        }
    },

    filters: {

        ...dashOverviewFilters,

    },

    created() {
        this.initDate = this.provider.created_at
    },


    computed: {

        ...mapGetters({ provider: 'ProviderVuex/provider'})

    },

    methods: {

        ...mapActions({ getTablesData: `ProviderVuex/${GET_DASHDATA}` }),

        async changePeriod() {

            this.loading2 = true

            await this.getTablesData({ id: this.provider._id, initDate: this.initDate, endDate: this.endDate });

            this.$emit('showAlert', { initDate: this.initDate, endDate: this.endDate })

            this.loading2 = false

            this.filtering = false
            this.btnFilter = true
            this.filterAlert = true

        },

        async choseFilter() {

            this.btnFilter = false
            this.filtering = true

        },
    },
}

</script>

<style scoped>

.initDate-input {

    width: 100%;
    max-width: 300px;
}

.endDate-input {

    width: 100%;
    max-width: 300px;
}


</style>